import { PageHeader } from "../common/PageHeader";
import MonitorEventList from "./MonitorEventList";
import * as authSelectors from "../auth/authSelectors";
import { useSelector } from "react-redux";

export const OrganizationMonitorEventList = () => {
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );

  return (
    <div className="container">
      <PageHeader
        title="Organization Monitor Events"
        breadcrumbs={[{ title: "Monitor Events", isActive: true }]}
      />

      <div className="row row-cards row-deck">
        <div className="col-12">
          <MonitorEventList
            organization={organizationKeyName}
            isVisibleEmailFilter={true}
            isVisibleEventTypeFilter={true}
          />
        </div>
      </div>
    </div>
  );
};
